import React from 'react';
import { Link } from 'react-router-dom';
import { Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CloseBtn, ProjectItemBtn, StyledModalBox } from '#component/user/dashboard/styles';

const ProjectsModal = ({ isOpen, onClose, projects }) => (
  <Modal
    open={isOpen}
    onClose={onClose}
    aria-labelledby="projects-modal-title"
    aria-describedby="projects-modal-description"
  >
    <StyledModalBox>
      <CloseBtn
        aria-label="close"
        onClick={onClose}
      >
        <CloseIcon />
      </CloseBtn>
      <Typography gutterBottom variant="h4" pb={2} id="projects-modal-title">Projects</Typography>
      {projects && (
        <div id="projects-modal-description">
          {projects.map(project => (
            <ProjectItemBtn
              key={project.id}
              color="secondary"
              aria-label="Project"
              component={Link}
              to={`/project/edit/${project.id}`}
            >
              {project.title}
            </ProjectItemBtn>
          ))}
        </div>
      )}
    </StyledModalBox>
  </Modal>
);

export default ProjectsModal;
